( function($) {
    /*
     * Adding to cart.
     */
    $('[data-birthday-card-add]').on('click', function () {
        addCardToCart( $(this).closest('.birthday-card-popup') );
        $('.birthday-card-popup').fadeOut(function() {
          $(this).attr('aria-hidden', true)
        });
    });

    $('.birthday-card-popup__inner').on('click', function (e) {
        e.stopPropagation();
    });

    $('[data-birthday-card-cancel]').on('click', function (e) {
        e.preventDefault();
        $('.birthday-card-popup').fadeOut(function() {
          $(this).attr('aria-hidden', true)
        });
    });

    $('[data-birthday-card-open]').on('click', function(e) {
        e.preventDefault();
        $('.birthday-card-popup').fadeIn(function() {
          $(this).attr('aria-hidden', false)
        });
    })

    function addCardToCart( $birthdayCard ) {

        $.post('/cart/add.js', {
            id: $birthdayCard.data('variant-id'),
            quantity: 1
        }, function (response) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true
            }));
        }, 'json');
    }
    
} (jQuery)); 
